import { render, staticRenderFns } from "./IDTMenu.vue?vue&type=template&id=0f8abe11&scoped=true&"
import script from "./IDTMenu.vue?vue&type=script&lang=js&"
export * from "./IDTMenu.vue?vue&type=script&lang=js&"
import style0 from "./IDTMenu.vue?vue&type=style&index=0&id=0f8abe11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8abe11",
  null
  
)

export default component.exports